export default "__VITE_ASSET__Dn1nP6BH__"